<template>
	<div class="memberLog layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				未读消息
			</div>
		</div>
		<table class="layui-table align_center" id="orders" style="width:90%;margin:30px 5% 0;">
			<colgroup>
				<col width="150">
				<col width="300">
				<col width="200">
				<col>
				<col width="200">
			</colgroup>
			<thead>
				<tr>
					<th class="align_center">序号</th>
					<th class="align_center">订单编号</th>
					<th class="align_center">消息来源</th>
					<th class="align_center">时间</th>
					<th class="align_center">操作</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item,i) in datas" :key="i">
					<td>{{i+1}}</td>
					<td>{{item.order_num}}</td>
					<td>企业客户</td>
					<td>{{item.time}}</td>
					<td>
						<button @click="showDetails(item.order_num,item.order_id)" class="layui-btn zt_color">回复</button>
					</td>
				</tr>
				<tr v-if="datas.length == 0">
					<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="5">暂无数据</td>
				</tr>
			</tbody>
		</table>
		<div id="lypages" style="margin-left: 5%;"></div>
	</div>
</template>

<script>
	export default {
		name: 'memberLog',
		data() {
			return {
				datas: [],
			}
		},
		created() {
			this.getData();
		},
		mounted() {

		},
		methods: {
			getData() {
				let _this = this;
				api.getAllMsgStatus({
					token: this.getCookie('token'),
					type: 2,
					from_user: 2, //1工程师发送，2企业发送
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							res.data[i].time = _this.getTimes(res.data[i].createtime);
						}
						_this.datas = res.data;
					}
				})
			},
			showDetails(order_num,id) {
				this.$router.push({
					path: '/communicate',
					query: {
						order_num: order_num,
						id: id
					}
				})
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/news.vue